export default __webpack_public_path__ + "static/title-news-zh-Hans-649f339988ce4c530b028c114c53886c.png";